//IB WALLET BALANCE

import api from "../../utils/axiosInstance.js";
import { GET_SPOT_ORDER_BOOK, GET_SPOT_ORDER_BOOK_ERROR, GET_SPOT_ORDER_BOOK_REQUEST, UPDATE_SPOT_ORDER_BOOK_DATA, REMOVE_SPOT_ORDER_BOOK } from "../../ActionTypes/ActionTypes.js";


const getSTOrderBookRequest = () => ({ type: GET_SPOT_ORDER_BOOK_REQUEST });
const getSTOrderBookSuccess = (data) => ({ type: GET_SPOT_ORDER_BOOK, payload: data });
const getSTOrderBookError = (error) => ({ type: GET_SPOT_ORDER_BOOK_ERROR, payload: error });

export const getSTOrderBookList = (data) => async (dispatch) => {
    dispatch(getSTOrderBookRequest());
    try {


        const response = await api.post(`/spot/allspotorders`, data);

        if (response.data.success) {
            dispatch(getSTOrderBookSuccess(response.data));

        }
        else {
            dispatch(getSTOrderBookError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getSTOrderBookError(error.response?.data?.message || error.message));
    }
};

export const updateSTOrderBookData = (newData) => ({
    type: UPDATE_SPOT_ORDER_BOOK_DATA,
    payload: newData,
});


export const removeSTOrderBookData = (newData) => ({
    type: REMOVE_SPOT_ORDER_BOOK,
    payload: newData,
});

